import { render, staticRenderFns } from "./update-release-authorization.component.vue?vue&type=template&id=8c3cd9a6&"
import script from "./update-release-authorization.component.vue?vue&type=script&lang=ts&"
export * from "./update-release-authorization.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports